import React, { MouseEventHandler } from 'react';
import Typography from '@mui/material/Typography';
import WidgetCard from 'components/Widget/WidgetCard';
import { WidgetT } from 'routes/Dashboard/components/WidgetsLayout/helpers';
import { NestedMenuOptionT } from 'ui/NestedMenu/NestedMenu';

type Props = {
    editMode: boolean;
    canEdit: boolean;
    widget: WidgetT;
    menuItems: NestedMenuOptionT[];
    onDoubleClick: MouseEventHandler<HTMLDivElement>;
};
export default function TitleWidget({
    editMode,
    widget,
    menuItems,
    canEdit,
    onDoubleClick,
}: Props): React.ReactElement {
    return (
        <WidgetCard
            editMode={editMode}
            menuItems={menuItems}
            canEdit={canEdit}
            onDoubleClick={onDoubleClick}
        >
            <Typography variant="h4" sx={{ m: 'auto' }}>
                {widget.content?.text}
            </Typography>
        </WidgetCard>
    );
}
